<template>
  <div class="tabs">
    <div class="tabs-nav">
      <ul class="tab-list">
        <li
          v-for="(tab, index) in tabs"
          :class="[{ active: tab.isActive }, tab.name.toLowerCase()]"
          class="tab"
          v-bind:key="index"
        >
          <a :href="tab.href" @click="selectTab(tab)" class="link">
            <div class="nav-title h3" v-text="tab.name" />
            <div class="nav-date h4" v-text="tab.$attrs.date" />
            <div class="nav-location" v-text="tab.$attrs.location" />
            <div class="nav-time" v-text="tab.$attrs.time" />
          </a>
        </li>
      </ul>
    </div>
    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  data() {
    return { tabs: [] };
  },
  mounted() {
    this.tabs = this.$children;
  },
  props: {
    header: Array
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    }
  }
};
</script>

<style lang="scss">
.tabs {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.tab-list {
  display: flex;
  flex: 1;
}

.tab {
  text-decoration: none;
  color: #fff;
  flex: 1;
  text-align: center;

  .nav-title {
    margin-top: 16px;
    padding: 0 10px;
    color: #fff;
  }

  .nav-date {
    color: #fff;
  }

  .nav-location {
    color: #fff;
  }

  .nav-time {
    color: #fff;
  }

  .nav-events {
    color: #fff;
  }
}

.mehndi {
  background: #f7f7f7;

  &.tab {
    color: #333;

    .nav-title {
      color: #333;
    }

    .nav-date {
      color: #333;
    }

    .nav-location {
      color: #333;
    }

    .nav-time {
      color: #333;
    }

    .nav-events {
      color: #333;
    }
  }
}

.wedding {
  background: #8e8e8e;

  &.tab {
    color: #f7f7f7;

    .nav-title {
      color: #f7f7f7;
    }

    .nav-date {
      color: #f7f7f7;
    }

    .nav-location {
      color: #f7f7f7;
    }

    .nav-time {
      color: #f7f7f7;
    }

    .nav-events {
      color: #f7f7f7;
    }
  }
}

.reception {
  background: #333;

  &.tab {
    color: #f7f7f7;

    .nav-title {
      color: #f7f7f7;
    }

    .nav-date {
      color: #f7f7f7;
    }

    .nav-location {
      color: #f7f7f7;
    }

    .nav-time {
      color: #f7f7f7;
    }

    .nav-events {
      color: #f7f7f7;
    }
  }
}

.flights {
  background: #f7f7f7;

  &.tab {
    color: #333;

    .nav-title {
      color: #333;
    }
  }
}

.canmore {
  background: #8e8e8e;

  &.tab {
    color: #f7f7f7;

    .nav-title {
      color: #f7f7f7;
    }
  }
}

.budding {
  background: #545454;

  &.tab {
    color: #f7f7f7;

    .nav-title {
      color: #f7f7f7;
    }
  }
}

.things {
  background: #333;

  &.tab {
    color: #f7f7f7;

    .nav-title {
      color: #f7f7f7;
    }
  }
}

.link {
  text-decoration: none;
}
</style>
